import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Switch } from '@/components/ui/switch';
import { Languages } from 'lucide-react';
import { DinoLlamaLoader } from '@/components/DinoLlamaLoader';

export const LanguageToggle = ({ className = '', compact = false }) => {
  const { definitionLanguage, toggleLanguage, t, isTranslating } = useLanguage();
  const isSpanish = definitionLanguage === 'es';

  // Show the cute running dino/llama loader when translating
  if (isTranslating) {
    return (
      <div className={`flex items-center ${className}`}>
        <DinoLlamaLoader 
          message={isSpanish ? "Translating..." : "Traduciendo..."} 
          size="sm" 
        />
      </div>
    );
  }

  if (compact) {
    // Compact version for header
    return (
      <div className={`flex items-center gap-2 px-2 py-1 rounded-full bg-muted/50 ${className}`}>
        <span className={`text-xs font-medium transition-colors ${!isSpanish ? 'text-primary' : 'text-muted-foreground'}`}>
          EN
        </span>
        <Switch
          checked={isSpanish}
          onCheckedChange={toggleLanguage}
          aria-label={t('toggleLanguageLabel')}
          className="data-[state=checked]:bg-primary h-4 w-8"
        />
        <span className={`text-xs font-medium transition-colors ${isSpanish ? 'text-primary' : 'text-muted-foreground'}`}>
          ES
        </span>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 px-4 py-2 rounded-full bg-background/80 backdrop-blur-sm border shadow-sm ${className}`}>
      <Languages className="h-4 w-4 text-muted-foreground" />
      <span className={`text-sm font-medium transition-colors ${!isSpanish ? 'text-primary' : 'text-muted-foreground'}`}>
        English
      </span>
      <Switch
        checked={isSpanish}
        onCheckedChange={toggleLanguage}
        aria-label={t('toggleLanguageLabel')}
        className="data-[state=checked]:bg-primary"
      />
      <span className={`text-sm font-medium transition-colors ${isSpanish ? 'text-primary' : 'text-muted-foreground'}`}>
        Español
      </span>
    </div>
  );
};

export default LanguageToggle;
